export function adminDbAccess(args) {
  const {
    creating = false,
    allowlistEntries = [],
    allowlistUsable = false,
  } = args || {};

  // Get active tab from URL query param only if allowlist is usable
  const urlParams = new URLSearchParams(window.location.search);
  const tabFromUrl = allowlistUsable
    ? urlParams.get("tab") || "db_users"
    : "db_users";

  return {
    creating,
    activeTab: tabFromUrl,
    allowlistUsable,
    editingAllowlist: false,
    saving: false,
    allowlistEntries,
    currentRules: [], // The current state of rules being edited

    // Set active tab and update URL only if allowlist is usable
    setActiveTab(tab) {
      this.activeTab = tab;
      if (this.allowlistUsable) {
        const url = new URL(window.location);
        url.searchParams.set("tab", tab);
        window.history.pushState({}, "", url);
      }
    },

    startEditing() {
      // Copy current firewall rules to editable state
      const existingRules = this.allowlistEntries || [];
      this.currentRules = existingRules.map((rule) => ({
        id: rule.id,
        label: rule.label,
        ip_address: rule.ip_address,
      }));
      this.editingAllowlist = true;
    },

    cancelEditing() {
      this.currentRules = [];
      this.editingAllowlist = false;
    },

    addEntry() {
      const tempId = `new-${Date.now()}-${Math.random()}`;
      this.currentRules.push({
        tempId: tempId,
        label: "",
        ip_address: "",
      });
      // Focus the newly added label input on next tick
      this.$nextTick(() => {
        const newInput = document.querySelector(
          `[data-rule-id="${tempId}"] input[name="label"]`,
        );
        if (newInput) {
          newInput.focus();
        }
      });
    },

    toggleRuleForDeletion(ruleId) {
      const rule = this.currentRules.find((r) => (r.id || r.tempId) === ruleId);
      if (rule) {
        rule.deleted = !rule.deleted;
      }
    },

    isRuleMarkedForDeletion(ruleId) {
      const rule = this.currentRules.find((r) => (r.id || r.tempId) === ruleId);
      return rule?.deleted || false;
    },

    updateRule(ruleId, field, value) {
      const rule = this.currentRules.find((r) => (r.id || r.tempId) === ruleId);
      if (rule) {
        rule[field] = value;
      }
    },

    async saveChanges() {
      this.saving = true;

      try {
        // Filter out empty rules, deleted rules, and prepare the desired state
        const desiredRules = this.currentRules
          .filter((rule) => !rule.deleted && rule.label && rule.ip_address)
          .map((rule) => ({
            id: rule.id, // Will be undefined for new rules
            label: rule.label,
            ip_address: rule.ip_address,
          }));

        const requestBody = {
          rules: desiredRules,
        };

        // Submit changes to server
        const response = await fetch(
          "/admin/datacloud/dbaccess/update_allowlist",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            },
            body: JSON.stringify(requestBody),
          },
        );

        const responseData = await response.json().catch(() => null);

        if (response.ok) {
          // Update the local state with the response data
          if (responseData && responseData.rules) {
            this.allowlistEntries = responseData.rules;
          }

          this.editingAllowlist = false;
          this.currentRules = [];
          this.saving = false;

          // Show success notification using alert from response
          if (typeof pushNotification === "function" && responseData?.alert) {
            window.pushNotification({
              title: responseData.alert.title,
              desc: responseData.alert.desc,
            });
          }
        } else {
          // Show error notification using alert from response
          if (typeof pushNotification === "function" && responseData?.alert) {
            window.pushNotification({
              title: responseData.alert.title,
              desc: responseData.alert.desc,
              error: responseData.alert.error,
            });
          }
          const errorMessage =
            responseData?.error || "Failed to update IP addresses";
          throw new Error(errorMessage);
        }
      } catch (error) {
        console.error("Error updating IP addresses:", error);
        this.saving = false;
        alert(
          "An error occurred while updating the IP addresses. Please try again.",
        );
      }
    },
  };
}
